/**
 * Inline brand marks for the integration list. Lucide ships no third-party
 * logos, so these are self-contained SVGs that inherit `currentColor` (the
 * badge controls the color). Strava/Spotify use their official glyph paths;
 * Whoop uses its official Circle mark (ring + "W") from WHOOP's brand pack,
 * minus the tiny ® glyph that's illegible at icon sizes.
 */

interface BrandIconProps {
  className?: string;
}

export function StravaIcon({ className }: BrandIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
    </svg>
  );
}

export function SpotifyIcon({ className }: BrandIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.56.3z" />
    </svg>
  );
}

export function WhoopIcon({ className }: BrandIconProps) {
  return (
    <svg viewBox="0 0 30 30" className={className} fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 28.5C22.4558 28.5 28.5 22.4558 28.5 15C28.5 7.54416 22.4558 1.5 15 1.5C7.54416 1.5 1.5 7.54416 1.5 15C1.5 22.4558 7.54416 28.5 15 28.5ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
      />
      <path d="M6 9.5L8.55057 17.3372H10.1478L7.59855 9.5H6Z" />
      <path d="M22.4015 9.50004L19.1006 19.6442L17.3481 14.2602H15.7509L18.3015 22.1H19.9L24 9.50004H22.4015Z" />
      <path d="M10.1 22.1L14.2014 9.50004H15.7986L11.6986 22.1H10.1Z" />
    </svg>
  );
}
